import { ApiRestService } from '../_service/api-rest.service';
import { Check } from '../models/Check';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import {CheckList} from "../models/CheckList";
import {Todo} from "../models/todo";
import {Valutazione} from "../models/Valutazione";
import { ApiPathsService } from 'src/app/api-paths.service';

@Component({
  selector: 'app-check-list-valutazione',
  templateUrl: './check-list-valutazione.component.html'
})
export class CheckListValutazioneComponent implements OnInit {
  @Input() valutazione: Valutazione;
  @Input() Selected: Check[];
  @Input() CheckList: CheckList;
  @Output() CheckListChange = new EventEmitter<Check[]>();
  @Input() isModifyDisabled: boolean = false;
  OutcomeList: string[];
  constructor(private ApiRestService: ApiRestService, private toastService: ToastrService,private ApiPathsService: ApiPathsService) { }
  ngOnInit() {
    if(this.valutazione?.id)
    this.ApiRestService.getchecklist({id: this.valutazione.id}).subscribe(data=> {
      if(data){
        this.CheckList = data;
        if(this.CheckList.todo)
          this.todoDecode(this.CheckList.todo);
        this.OutcomeList = data.outcomes;
        console.log(this.OutcomeList)
        console.log(this.OutcomeList)
      }
    });
    else 
    this.ApiPathsService.ClassicPost('',{}).subscribe(data=>{})
  }

  todoDecode(todo: Todo[]){
    todo.forEach(element => {
      if (!element.figli || element.figli.length < 1)
        element.foglie.forEach((check)=>{
          const idx: number = this.Selected.findIndex(x=>x.id == check.id);
          if( idx > -1){
            check.esito = this.Selected[idx].esito || "";
            check.valore = this.Selected[idx].valore || 0;
          }else
            check.modifica = true;
        });
      else
        this.todoDecode(element.figli)
    });
  }



  onChange(item: Check){
    const idx: number = this.Selected.findIndex(x => x.id == item.id)
    if(idx>-1)
      this.Selected[idx] = item;
    else
      this.Selected.push(item)
  }

  edit(item: Check) {
    if(item.modifica ){
      if (item.esito != " " && item.esito != "" && item.esito != null){
        item.modifica = !item.modifica;
        const idx: number = this.Selected.findIndex(x => x.id == item.id)
        if(idx>-1)
          this.Selected[idx] = item;
        else
          this.Selected.push(item)
      }
      else
        this.toastService.warning("inserire un Esito", "Attenzione!!");
    }else {
      item.modifica = !item.modifica;
    }
  }
  delete(item: Check) {
    const idx: number = this.Selected.findIndex(x => x.id == item.id);
    if ( idx > -1) {
      this.Selected.splice(idx, 1);
    }
  }

}
